import { useEffect, useId, useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";

export default function ActionPanel({
  working = false, label = "Done", message, stillWorking = false,
  status = "success", onClose, onReload, closeLabel,
}) {
  const titleId = useId();
  const [elapsed, setElapsed] = useState(false);
  useEffect(() => {
    setElapsed(false);
    if (!working) return undefined;
    const timer = setTimeout(() => setElapsed(true), 60000);
    return () => clearTimeout(timer);
  }, [working, label]);
  return (
    <Box role="alertdialog" aria-labelledby={titleId} aria-busy={working} tabIndex={-1}
      sx={{ bgcolor: "background.paper", color: "text.primary", p: 3, borderRadius: 2,
        width: "100%", maxWidth: 600, maxHeight: "85vh", overflowY: "auto", boxSizing: "border-box" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {working && <CircularProgress size={28} />}
        <Typography id={titleId} variant="h6" aria-live="polite">{label}</Typography>
      </Box>
      {working && (stillWorking || elapsed) && <Typography sx={{ mt: 2 }}>
        Still working: this is taking longer than usual.
      </Typography>}
      {message && <Box sx={{ mt: 2, whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>{message}</Box>}
      {!working && <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 3 }}>
        {onReload && <Button onClick={onReload}>Reload</Button>}
        <Button variant="contained" onClick={onClose}>{closeLabel || (status === "timeout" ? "Close" : "OK")}</Button>
      </Box>}
    </Box>
  );
}
